import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import utils from './utils/utils.js'
import rem from './utils/rem'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'
// import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
// const app = createApp();
Vue.config.productionTip = false;
Vue.use(Antd);
Vue.prototype.$echarts = echarts
axios.defaults.baseURL = '/api';
Vue.prototype.axios = axios;
Vue.use(ElementUI);
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor);
router.beforeEach((to,from,next)=>{
  //判断是否需要登录
//   if (to.meta.isLogin) {
//     //判断是否登录
//     if(utils.getStorage('user')){
//     next()
//   } else {
//     router.push('/home/login')
//   }
// }else {
//   next()
// }
  next()
})
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');